import { Injectable } from '@angular/core';
import { UserProfile } from '../_models/user-profile';
import { BehaviorSubject } from 'rxjs';
import { PortalApps } from '../_models/portal-routes';
import { PortalAppRouteList } from '../_data/portal-route.list';

@Injectable({
  providedIn: 'root'
})
export class NavLinkAvailabilityService {
  private availableLinks = new BehaviorSubject<PortalApps[]>(PortalAppRouteList);

  availableLinks$ = this.availableLinks.asObservable();

  constructor() { }

  getAvailableLinks() {

  }

  updateAvailableLinks(updatedLinks: PortalApps[]) {
    this.availableLinks.next(updatedLinks);
  }

  checkWellsAccess() {
  }

  setUsersAccess(isAllowed: boolean) {
  }
}
